﻿class AnimatedCounter extends HTMLElement {
    private end: number = 0
    private duration: number = 2000
    private suffix: string = ""
    private count: number = 0
    private isVisible: boolean = false
    private observer: IntersectionObserver | null = null
    private span: HTMLSpanElement

    constructor() {
        super()
        this.span = document.createElement("span")
        this.span.textContent = "0"

        // Apply classes from data-class
        const classes = this.dataset.class
        if (classes) {
            this.span.className = classes
        }

        this.appendChild(this.span)
    }

    static get observedAttributes() {
        return ["end", "duration", "suffix", "data-class"]
    }

    attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
        if (name === "end") this.end = parseInt(newValue, 10)
        if (name === "duration") this.duration = parseInt(newValue, 10)
        if (name === "suffix") this.suffix = newValue
        if (name === "data-class") {
            this.span.className = newValue
        }
    }

    connectedCallback() {
        this.setupObserver()
    }

    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect()
        }
    }

    private setupObserver() {
        this.observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !this.isVisible) {
                    this.isVisible = true
                    this.startAnimation()
                }
            },
            { threshold: 0.1 }
        )

        this.observer.observe(this)
    }

    private startAnimation() {
        let startTime: number | null = null

        const animate = (currentTime: number) => {
            if (!startTime) startTime = currentTime
            const progress = Math.min((currentTime - startTime) / this.duration, 1)

            this.count = Math.floor(progress * this.end)
            this.span.textContent = this.formatNumber(this.count) + this.suffix

            if (progress < 1) {
                requestAnimationFrame(animate)
            }
        }

        requestAnimationFrame(animate)
    }

    private formatNumber(num: number): string {
        return num.toLocaleString("en-US")
    }
}

customElements.define("animated-counter", AnimatedCounter)
